import React from "react";
import QuranVerseLines from "./QuranVerseLines";

const QuranPageViewport = ({
  swipeViewportRef,
  useNativePageSwipe,
  nativeSwipeScrollerRef,
  onNativeSwipeScroll,
  onNativeSwipeTouchStart,
  onNativeSwipeTouchMove,
  onNativeSwipeTouchEnd,
  onNativeSwipeMouseDown,
  onNativeSwipeMouseMove,
  onNativeSwipeMouseUp,
  canNext,
  canPrev,
  renderPageContent,
  nextPagePresentation,
  nextPageLines,
  currentPagePresentation,
  lines,
  linesRef,
  prevPagePresentation,
  prevPageLines,
  swipePreview,
  swipePreviewTargetReady,
  swipeTargetLines,
  loadedPages,
  loadedFontFamilies,
  uthmanicFont,
  recitationSessionActive,
  recitationCurrentVerseKey,
  searchHighlightedVerseKey,
  onVersePointerDown,
  onVersePointerUp,
  onVersePointerCancel,
  showSurahBasmala,
  fatihaBasmalaLines,
  loading,
  pageTransitionClass,
  page,
  swipePreviewGapPx,
}) => (
  <div className="quran-lines-swipe-viewport" ref={swipeViewportRef}>
    {useNativePageSwipe ? (
      <div
        className="quran-native-swipe"
        dir="ltr"
        ref={nativeSwipeScrollerRef}
        onScroll={onNativeSwipeScroll}
        onTouchStartCapture={onNativeSwipeTouchStart}
        onTouchMoveCapture={onNativeSwipeTouchMove}
        onTouchEndCapture={onNativeSwipeTouchEnd}
        onTouchCancelCapture={onNativeSwipeTouchEnd}
        onMouseDownCapture={onNativeSwipeMouseDown}
        onMouseMoveCapture={onNativeSwipeMouseMove}
        onMouseUpCapture={onNativeSwipeMouseUp}
        onMouseLeave={onNativeSwipeMouseUp}
      >
        <div className={`quran-native-swipe-panel ${canNext ? "" : "quran-native-swipe-panel--blocked"}`.trim()} dir="rtl">
          {canNext
            ? renderPageContent({
                presentation: nextPagePresentation,
                pageLines: nextPageLines,
                interactive: false,
                linesClassName: "quran-native-swipe-lines",
              })
            : null}
        </div>

        <div className="quran-native-swipe-panel" dir="rtl">
          {renderPageContent({
            presentation: currentPagePresentation,
            pageLines: lines,
            interactive: true,
            linesClassName: "quran-native-swipe-lines",
            linesRefProp: linesRef,
          })}
        </div>

        <div className={`quran-native-swipe-panel ${canPrev ? "" : "quran-native-swipe-panel--blocked"}`.trim()} dir="rtl">
          {canPrev
            ? renderPageContent({
                presentation: prevPagePresentation,
                pageLines: prevPageLines,
                interactive: false,
                linesClassName: "quran-native-swipe-lines",
              })
            : null}
        </div>
      </div>
    ) : swipePreview.active ? (
      <div className="quran-lines-swipe-stage">
        <div className="quran-lines quran-lines-swipe-placeholder" aria-hidden="true">
          <QuranVerseLines
            lines={lines}
            loadedPages={loadedPages}
            loadedFontFamilies={loadedFontFamilies}
            uthmanicFont={uthmanicFont}
            recitationSessionActive={recitationSessionActive}
            recitationCurrentVerseKey={recitationCurrentVerseKey}
            searchHighlightedVerseKey={searchHighlightedVerseKey}
            interactive={false}
            onVersePointerDown={onVersePointerDown}
            onVersePointerUp={onVersePointerUp}
            onVersePointerCancel={onVersePointerCancel}
            showSurahBasmala={showSurahBasmala}
            fatihaBasmalaLines={fatihaBasmalaLines}
          />
        </div>

        {swipePreviewTargetReady && (
          <div
            className={`quran-lines quran-lines-panel quran-lines-panel--target ${loading ? "quran-lines--loading" : ""} ${
              swipePreview.settling ? "quran-lines-panel--settling" : ""
            }`}
            style={{
              left:
                swipePreview.direction === "next"
                  ? `calc(${swipePreview.offsetX}px - 100% - ${swipePreviewGapPx}px)`
                  : `calc(${swipePreview.offsetX}px + 100% + ${swipePreviewGapPx}px)`,
            }}
          >
            <QuranVerseLines
              lines={swipeTargetLines}
              loadedPages={loadedPages}
              loadedFontFamilies={loadedFontFamilies}
              uthmanicFont={uthmanicFont}
              recitationSessionActive={recitationSessionActive}
              recitationCurrentVerseKey={recitationCurrentVerseKey}
              searchHighlightedVerseKey={searchHighlightedVerseKey}
              interactive={false}
              onVersePointerDown={onVersePointerDown}
              onVersePointerUp={onVersePointerUp}
              onVersePointerCancel={onVersePointerCancel}
            />
          </div>
        )}

        <div
          key={`quran-lines-${page}`}
          className={`quran-lines quran-lines-panel quran-lines-panel--current ${loading ? "quran-lines--loading" : ""} ${
            !swipePreview.active ? pageTransitionClass : ""
          } ${swipePreview.settling ? "quran-lines-panel--settling" : ""}`}
          style={{ left: `${swipePreview.offsetX}px` }}
          ref={linesRef}
        >
          <QuranVerseLines
            lines={lines}
            loadedPages={loadedPages}
            loadedFontFamilies={loadedFontFamilies}
            uthmanicFont={uthmanicFont}
            recitationSessionActive={recitationSessionActive}
            recitationCurrentVerseKey={recitationCurrentVerseKey}
            searchHighlightedVerseKey={searchHighlightedVerseKey}
            interactive={true}
            onVersePointerDown={onVersePointerDown}
            onVersePointerUp={onVersePointerUp}
            onVersePointerCancel={onVersePointerCancel}
            showSurahBasmala={showSurahBasmala}
            fatihaBasmalaLines={fatihaBasmalaLines}
          />
        </div>
      </div>
    ) : (
      <div
        key={`quran-lines-${page}`}
        className={`quran-lines ${loading ? "quran-lines--loading" : ""} ${pageTransitionClass}`}
        ref={linesRef}
      >
        <QuranVerseLines
          lines={lines}
          loadedPages={loadedPages}
          loadedFontFamilies={loadedFontFamilies}
          uthmanicFont={uthmanicFont}
          recitationSessionActive={recitationSessionActive}
          recitationCurrentVerseKey={recitationCurrentVerseKey}
          searchHighlightedVerseKey={searchHighlightedVerseKey}
          interactive={true}
          onVersePointerDown={onVersePointerDown}
          onVersePointerUp={onVersePointerUp}
          onVersePointerCancel={onVersePointerCancel}
          showSurahBasmala={showSurahBasmala}
          fatihaBasmalaLines={fatihaBasmalaLines}
        />
      </div>
    )}
  </div>
);

export default QuranPageViewport;